import styled from "styled-components";

export const MonthSettlementNetIncomeContentWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 37px;
  width: 100%;
`;

export const MonthSettlementNetIncomeGraphWrapper = styled.div`
  width: 1091px;
  position: relative;

  #chartjs-tooltip {
    position: absolute;
    background-size: cover;
    border-radius: 6px;
    pointer-events: none;
    transition: all 0.1s ease;
    opacity: 0;
    width: 233px;
    height: 181px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    background-image: url("/image-web/solution/pointer.svg");

    > .wrapper {
      padding: 15px 20px;

      > .header {
        color: #121212;
        font-family: Pretendard;
        font-size: 19px;
        font-weight: 700;
        margin-bottom: 18px;
      }

      > .content {
        display: flex;
        flex-direction: column;
        gap: 10px;

        > .info {
          display: flex;
          justify-content: space-between;
          font-family: Pretendard;
          font-size: 15px;
          font-weight: 600;
        }
      }
    }
  }
  #line {
    width: 0px;
    border-right: 2px dashed #422f8ade;
    position: absolute;
  }
`;

export const MonthSettlementNetIncomeBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const MonthSettlementNetIncomeTableContentWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
